import React from 'react';
import styles from './styles.module.css';
import { Icon } from 'common/icon';

export const SupportInfo = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const openSupportChat = () => {
    setIsOpen(!isOpen);
    window.$chatwoot?.toggle?.();
  };

  return (
    <div onClick={openSupportChat} className={styles.supportSection}>
      <div className={styles.supportContent}>
        <div className={styles.supportIconWrapper}>
          <Icon.Headphones />
        </div>
        <div className={styles.supportTextContainer}>
          <h3 className={styles.teamTitle}>RTPCheck Team</h3>
          <p className={styles.supportText}>Support 24/7</p>
        </div>
      </div>
      {isOpen ? <Icon.CloseSecond /> : <Icon.Windows />}
    </div>
  );
};
